import logToConsole from '../Utils/logToConsole';

export const isValidCampaignId = (campaignId) => {
  if (typeof campaignId !== 'string') {
    return false;
  }
  return /^[0-9a-f]{13,}$/.test(campaignId);
};

export const getCampaignIdTrumpedByUrl = (
  campaignId,
  url,
  useCidFromURL = true
) => {
  if (useCidFromURL === false) {
    return campaignId;
  }

  if (typeof url !== 'string') {
    return campaignId;
  }

  try {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const cidFromUrl = params.get('cid');
    if (cidFromUrl && isValidCampaignId(cidFromUrl)) {
      return cidFromUrl;
    }
  } catch (error) {
    logToConsole.warn('Error parsing URL:', error.message);
  }

  return campaignId;
};
